<template>
    <BlockUI :blocked="proc">
      <ol class="breadcrumb">
        <router-link to="/" class="breadcrumb-item"> Dashboard </router-link>
        <router-link to="/settledGames" class="breadcrumb-item">
          <span>Settled Matches</span>
        </router-link>
        <router-link to="/profitandloss" class="breadcrumb-item textdecorationnone">
          <span class="colorbase">{{ id1 }}</span>
        </router-link>
        <router-link to="/statement" class="breadcrumb-item">
          <span>My Stmt.</span>
        </router-link>
        <router-link to="/ledgers" class="breadcrumb-item">
          <span>Company Ledgers</span>
        </router-link>
        <router-link to="/collectionReport" class="breadcrumb-item">
          <span>Collection Report</span>
        </router-link>
        <router-link to="/liveGames" class="breadcrumb-item">
          <span>Live Matches</span>
        </router-link>
      </ol>
      <div class="row">
        <div class="col-xs-12">
          <router-link :to="'/betslips/' + id + '/' + id1 + '/' + sp" type="button" class="btn btn-sm btn-indigo marginright5">Bet Slips</router-link>
          <router-link :to="'/betslips2/' + id + '/' + id1 + '/' + sp" type="button" class="btn btn-sm btn-indigo marginright5">Bet Slips2</router-link>
          <router-link :to="'/sessionbetslips/' + id + '/' + id1 + '/' + sp" type="button" class="btn btn-sm btn-indigo marginright5" v-if="sp === 'Cricket'">Session Bet Slips</router-link>
          <button type="button" class="btn btn-sm btn-indigo marginright5">Live Report</button>
          <router-link :to="'/clientreport/' + id + '/' + id1 + '/' + sp" type="button" class="btn btn-sm btn-indigo marginright5">Client Report</router-link>
          <router-link :to="'/collectionreport1/' + id + '/' + id1 + '/' + sp" type="button" class="btn btn-sm btn-indigo marginright5">Collection Report</router-link>
          <router-link :to="'/companyreport/' + id + '/' + id1 + '/' + sp" type="button" class="btn btn-sm btn-indigo marginright5">Company Report</router-link>
          <router-link :to="'/sessionearningsreport/' + id + '/' + id1 + '/' + sp" type="button" class="btn btn-sm btn-indigo" v-if="sp === 'Cricket'">Session Earning Report</router-link>
        </div>
      </div>
    </BlockUI>
  </template>
  
  <script>
  import $$vm from "@/data/index";
  import BlockUI from "primevue/blockui";
  
  export default {
    name: "SettledGamesDetail",
    components: {
      BlockUI,
    },
    data() {
      return {
        id: "",
        id1: "",
        sp: "",
        proc: false,
      };
    },
    mounted() {
      this.update();
    },
    methods: {
      update: function () {
        var self = this;
        self.maxd = new Date();
        if (self.$route.params.id !== undefined && self.$route.params.id !== self.id) {
          self.id = self.$route.params.id;
        }
        if (self.$route.params.id1 !== undefined && self.$route.params.id1 !== self.id1) {
          self.id1 = self.$route.params.id1;
        }
        if (self.$route.params.sp !== undefined && self.$route.params.sp !== self.sp) {
          self.sp = self.$route.params.sp;
        }
        setTimeout(function () {
          self.update();
        }, 1000);
      },
    },
  };
  </script>
  
  <style></style>
  